import * as React from 'react';
import styled from '../theme';

interface ILangBtnProps {
    locale: string
    class: string
    id: string
    isPreArrival?: boolean
    changeLocale(e: React.FormEvent<HTMLButtonElement>): void
}

const LanguageButton = (props: ILangBtnProps) => (
    props.isPreArrival ?
        <TouristButton id={props.id} onClick={props.changeLocale} className={props.class}>
            {props.locale}
        </TouristButton> :
        <Button id={props.id} onClick={props.changeLocale} className={props.class}>
            {props.locale}
        </Button>
)

export default LanguageButton;

const Button = styled.button`
    width: 110px;
    height: 40px;
    display: inline-block;
    border-radius: 5px;
    border: none;
    color: white;
    font-size: 0.9em;
    font-weight: 400;
    text-align: center;
    margin: 0 10px;
    outline: none;
    background: ${(props: any) => props.theme.colors.backgroundDark2};
    background: -webkit-linear-gradient(${(props: any) => props.theme.colors.backgroundDark2}, ${(props: any) => props.theme.colors.backgroundDark3});
    background: linear-gradient(${(props: any) => props.theme.colors.backgroundDark2}, ${(props: any) => props.theme.colors.backgroundDark3});

    &.selected {
        background: -webkit-linear-gradient(${(props: any) => props.theme.colors.backgroundDark3}, ${(props: any) => props.theme.colors.backgroundDark2});
        background: linear-gradient(${(props: any) => props.theme.colors.backgroundDark3}, ${(props: any) => props.theme.colors.backgroundDark2});
        outline: none;
        border: 1px solid ${(props: any) => props.theme.colors.backgroundHighlight};
    }
`

const TouristButton = styled.button`
width: 120px;
height: 40px;
display: inline-block;
border: 1px solid ${(props: any) => props.theme.Borders_hover_colour};
color: ${(props: any) => props.theme.Borders_hover_colour};
font-size: 0.9em;
font-weight: 400;
text-align: center;
margin: 0 10px;
outline: none;
background: white;

&.selected {
    background: ${(props: any) => props.theme.Borders_hover_colour};
    outline: none;
    border: 1px solid ${(props: any) => JSON.parse(props.theme.colors).backgroundHighlight};
    color: white;
}
`



// WEBPACK FOOTER //
// ./src/components/LanguageButton.tsx